module.exports = __webpack_public_path__ + "img/newShirts@2x.cf0e97b4.png";